/*
 * Truly Indian site tracker
 * Sends anonymous site activity to the "Truly Indian Where to Find activity"
 * Google Form, and a copy of each contact-form message to the
 * "Website inquiries" Google Form. Both feed the same Google Sheet.
 *
 * - Never sends names, emails or messages to the activity form.
 * - Activity is skipped for visitors who opted out of analytics
 *   (Shopify privacy banner / "Your Privacy Choices") or send Global Privacy Control.
 * - Store locator searches and buy-online clicks are still logged by
 *   store-locator-page.js; this file adds source + device to those rows
 *   and applies the same opt-out check.
 */
(function () {
  "use strict";
  if (window.TITrack) return;

  var ACTIVITY_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSefghmj4CVu2rwzIFd2JrZvu0_lTZgFmgWZrizHZ76mMQ45yg/formResponse";
  var INQUIRY_URL =
    "https://docs.google.com/forms/d/e/1FAIpQLSd0b5VoK9zcYMs3JWeAtJ4U46ww53fYBOgWsRf-y81KVhzzDw/formResponse";

  var F = {
    type: "entry.763747866",
    session: "entry.1099249773",
    action: "entry.1962784986",
    query: "entry.45906970",
    state: "entry.602112085",
    product: "entry.1576281329",
    results: "entry.647354488",
    store: "entry.1008473500",
    retailer: "entry.491392636",
    page: "entry.700711350",
    source: "entry.1715022991",
    device: "entry.437249972",
    detail: "entry.240317676",
  };
  var Q = {
    name: "entry.88976523",
    email: "entry.1908028263",
    phone: "entry.388036497",
    topic: "entry.1224426950",
    page: "entry.1897769390",
    message: "entry.1724814215",
  };

  var SESSION_KEY = "ti_wheretofind_session"; // shared with store-locator-page.js
  var SOURCE_KEY = "ti_source";
  var LANDED_KEY = "ti_landed";

  function store(key, value) {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, value);
    } catch (e) {}
    return value;
  }

  function sessionId() {
    var id = store(SESSION_KEY);
    if (!id) id = store(SESSION_KEY, Math.random().toString(36).slice(2, 8));
    return id || "";
  }

  function hostOf(url) {
    try {
      return new URL(url).hostname.replace(/^www\./, "");
    } catch (e) {
      return "";
    }
  }

  function computeSource() {
    var p = new URLSearchParams(location.search);
    var utm = p.get("utm_source");
    if (utm) {
      return [utm, p.get("utm_medium"), p.get("utm_campaign")]
        .filter(Boolean)
        .join(" / ")
        .toLowerCase()
        .slice(0, 100);
    }
    if (p.get("gclid") || p.get("gbraid") || p.get("wbraid")) return "google / paid";
    if (p.get("fbclid")) return "facebook / social";
    if (p.get("ttclid")) return "tiktok / paid";
    if (p.get("_kx") || p.get("klaviyo")) return "klaviyo / email";
    var ref = hostOf(document.referrer);
    if (!ref || ref === location.hostname.replace(/^www\./, "")) return "direct";
    if (/google\./.test(ref)) return "google / organic";
    if (/bing\.|duckduckgo|yahoo\./.test(ref)) return ref.split(".")[0] + " / organic";
    if (/instagram/.test(ref)) return "instagram / social";
    if (/facebook|fb\.com/.test(ref)) return "facebook / social";
    if (/tiktok/.test(ref)) return "tiktok / social";
    if (/pinterest/.test(ref)) return "pinterest / social";
    if (/linkedin|lnkd\.in/.test(ref)) return "linkedin / social";
    if (/t\.co$|twitter|x\.com/.test(ref)) return "x / social";
    if (/mail\./.test(ref)) return ref + " / email";
    return ref + " / referral";
  }

  function source() {
    var s = store(SOURCE_KEY);
    if (!s) s = store(SOURCE_KEY, computeSource());
    return s || "";
  }

  function device() {
    var ua = navigator.userAgent || "";
    if (/iPad|Tablet/i.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)) return "tablet";
    if (/Android/i.test(ua) && !/Mobile/i.test(ua)) return "tablet";
    if (/Mobi|iPhone|iPod|Android/i.test(ua)) return "mobile";
    return "desktop";
  }

  function allowed() {
    if (navigator.globalPrivacyControl === true) return false;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && typeof cp.analyticsProcessingAllowed === "function") {
      try {
        return cp.analyticsProcessingAllowed() !== false;
      } catch (e) {}
    }
    return true;
  }

  function encode(obj) {
    return Object.keys(obj)
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k] == null ? "" : String(obj[k]));
      })
      .join("&");
  }

  function post(url, body) {
    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([body], { type: "application/x-www-form-urlencoded;charset=UTF-8" });
        if (navigator.sendBeacon(url, blob)) return;
      }
    } catch (e) {}
    try {
      nativeFetch(url, {
        method: "POST",
        mode: "no-cors",
        keepalive: true,
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: body,
      });
    } catch (e) {}
  }

  var sentKeys = {};
  function send(ev) {
    if (!allowed()) return;
    var key = [ev.type, ev.action, ev.product, ev.detail, ev.results].join("|");
    var now = Date.now();
    if (sentKeys[key] && now - sentKeys[key] < 1500) return;
    sentKeys[key] = now;
    var fields = {};
    fields[F.type] = ev.type || "";
    fields[F.session] = sessionId();
    fields[F.action] = ev.action || "";
    fields[F.query] = "";
    fields[F.state] = "";
    fields[F.product] = String(ev.product || "").slice(0, 120);
    fields[F.results] = ev.results === 0 || ev.results ? String(ev.results) : "";
    fields[F.store] = "";
    fields[F.retailer] = String(ev.retailer || "").slice(0, 40);
    fields[F.page] = String(location.pathname || "").slice(0, 180);
    fields[F.source] = source();
    fields[F.device] = device();
    fields[F.detail] = String(ev.detail || "").slice(0, 200);
    post(ACTIVITY_URL, encode(fields));
  }

  // Add source + device to rows sent by store-locator-page.js, and apply the opt-out check.
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === "string" ? input : input && input.url;
        if (url === ACTIVITY_URL && init && typeof init.body === "string" && init.body.indexOf(F.device) === -1) {
          if (!allowed()) return Promise.resolve(new Response(null, { status: 204 }));
          init.body += "&" + encode((function () {
            var o = {};
            o[F.source] = source();
            o[F.device] = device();
            return o;
          })());
        }
      } catch (e) {}
      return nativeFetch(input, init);
    };
  }

  function text(el) {
    return el ? String(el.textContent || "").replace(/\s+/g, " ").trim() : "";
  }

  function pageTitle() {
    var h1 = document.querySelector("main h1, #main-content h1, h1");
    var t = text(h1);
    if (t) return t.slice(0, 120);
    var og = document.querySelector('meta[property="og:title"]');
    return og ? String(og.content || "").slice(0, 120) : document.title.slice(0, 120);
  }

  var path = location.pathname.replace(/\/$/, "") || "/";
  var isProduct = /^\/products\//.test(path);
  var isRecipe = /^\/blogs\/news\/[^/]+/.test(path);
  var MERCH = ["merch", "samosa-express", "bold-flavors", "tikka-tikka-tikka", "scattered-hearts", "wordmark", "corner-heart", "stacked-wordmark", "all-over"];
  var pageHandle = (path.match(/^\/pages\/([^/]+)/) || [])[1] || "";
  var isMerch = MERCH.indexOf(pageHandle) !== -1;
  var isGame = pageHandle === "game";

  function pageName() {
    var view = "";
    try {
      view = new URLSearchParams(location.search).get("view") || "";
    } catch (e) {}
    var hash = (location.hash || "").replace(/^#filter-/, "").replace(/-/g, " ");
    if (path === "/") return "Home";
    if (path === "/pages/store-locator") return "Where to buy";
    if (path === "/blogs/news") return "Recipes";
    if (path.indexOf("/blogs/press") === 0) return "Press";
    if (path === "/pages/about" && view.indexOf("category") !== -1) return "Products";
    if (path === "/pages/about" && view.indexOf("reinvent") !== -1) return "Recipes";
    if (path === "/pages/about") return "About";
    if (isGame) return "Samosa Stack";
    if (/^\/collections\//.test(path)) {
      var handle = (path.split("/")[2] || "all").replace(/-/g, " ");
      if (hash) return "Shop: " + hash;
      if (handle === "all") return "Shop all";
      return "Shop: " + handle;
    }
    if (isProduct || isRecipe || isMerch) return pageTitle();
    return pageTitle() || path;
  }

  function trackViews() {
    if (!store(LANDED_KEY)) {
      store(LANDED_KEY, "1");
      send({ type: "view", action: "landing", detail: hostOf(document.referrer) || "direct" });
    }
    send({ type: "view", action: "page_view", product: pageName(), detail: path });
    if (isProduct) send({ type: "view", action: "product_view", product: pageTitle() });
    else if (isRecipe) send({ type: "view", action: "recipe_view", product: pageTitle() });
    else if (isMerch) send({ type: "view", action: "merch_view", product: pageHandle === "merch" ? "Merch page" : pageTitle() });
    else if (isGame) send({ type: "view", action: "game_view", product: "Samosa Stack" });
  }

  var TAB_LABEL = /^(description|how to use|ingredients\s*&(amp;)?\s*nutrition|nutrition|ingredients)$/i;

  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest("[data-sl-track]")) return; // logged by store-locator-page.js

    var tab = t.closest(".recipe-collection-grid__tab");
    if (tab) return send({ type: "click", action: "recipe_filter", detail: text(tab) });

    var a = t.closest("a[href]");
    var href = a ? a.getAttribute("href") || "" : "";

    if (a && /\/blogs\/news\/[^/?#]+/.test(href) && !isRecipe) {
      var card = a.closest(".recipe-card, article, li, [class*='recipe']");
      var title = text(card && card.querySelector("h2, h3, h4, [class*='title']")) || text(a);
      return send({ type: "click", action: "recipe_click", product: title.slice(0, 120), detail: text(a).slice(0, 60) });
    }

    if (a && /\/pages\/store-locator/.test(href)) {
      return send({ type: "click", action: "where_to_buy_click", product: isProduct ? pageTitle() : "", detail: text(a).slice(0, 60) });
    }

    if (a && /\/collections\//.test(href)) {
      var filter = (href.split("#filter-")[1] || "").split("&")[0].replace(/-/g, " ");
      var handle = (href.match(/\/collections\/([^/?#]+)/) || [])[1] || "";
      var category = filter || (handle && handle !== "all" ? handle.replace(/-/g, " ") : "all");
      return send({ type: "click", action: "shop_category", detail: category.slice(0, 60), product: text(a).slice(0, 60) });
    }

    if (a && isMerch) {
      var m = href.match(/\/pages\/([^/?#]+)/);
      if (m && MERCH.indexOf(m[1]) !== -1 && m[1] !== pageHandle) {
        return send({ type: "click", action: "merch_click", product: m[1], detail: text(a).slice(0, 60) });
      }
    }

    if (isProduct) {
      var ctl = t.closest("button, summary, [role='tab'], a, label, .tab, [class*='tab']");
      var label = text(ctl);
      if (ctl && TAB_LABEL.test(label)) {
        return send({ type: "click", action: "product_tab", product: pageTitle(), detail: label });
      }
      if (ctl && /\b\d*\s*reviews?\b/i.test(label) && label.length < 40) {
        return send({ type: "click", action: "reviews_open", product: pageTitle(), detail: label });
      }
    }
  }

  function onChange(e) {
    var el = e.target;
    if (el && el.id === "RecipeSortSelect") {
      var opt = el.options[el.selectedIndex];
      send({ type: "click", action: "recipe_sort", detail: opt ? text(opt) : el.value });
    }
  }

  function fieldValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || "").trim() : "";
  }

  function onSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== "FORM") return;
    var formType = fieldValue(form, "form_type");
    var email = form.querySelector('input[type="email"], input[name="contact[email]"], input[name="email"]');

    if (formType === "contact") {
      // Copy of the message for the Inquiries tab (sent whatever the analytics choice:
      // the visitor is writing to Truly Indian, and Shopify emails the same details).
      var known = { "contact[name]": 1, "contact[email]": 1, "contact[phone]": 1, "contact[body]": 1 };
      var extras = [];
      Array.prototype.forEach.call(form.querySelectorAll('[name^="contact["]'), function (el) {
        if (!known[el.name] && el.value) extras.push(el.name.slice(8, -1) + ": " + el.value);
      });
      var q = {};
      q[Q.name] = fieldValue(form, "contact[name]");
      q[Q.email] = fieldValue(form, "contact[email]");
      q[Q.phone] = fieldValue(form, "contact[phone]");
      q[Q.topic] = extras.join(" | ").slice(0, 300);
      q[Q.page] = location.pathname;
      q[Q.message] = fieldValue(form, "contact[body]").slice(0, 5000);
      post(INQUIRY_URL, encode(q));
      send({ type: "signup", action: "contact_submit", detail: q[Q.topic] ? "with topic" : "" });
      return;
    }

    if (email && email.value && (formType === "customer" || /newsletter|subscribe|signup|join/i.test(form.className + " " + form.id + " " + (form.getAttribute("action") || "")) || formType === "")) {
      if (form.closest("[data-store-locator-finder]")) return;
      var section = form.closest("footer, [id^='shopify-section']");
      var where = section ? (section.tagName === "FOOTER" ? "footer" : section.id.replace("shopify-section-", "").replace(/^template--\d+__/, "").replace(/^sections--\d+__/, "")) : "";
      send({ type: "signup", action: "newsletter_signup", detail: where.slice(0, 60) });
    }
  }

  function onGame(e) {
    var d = (e && e.detail) || {};
    if (d.action === "game_over") {
      send({
        type: "game",
        action: "game_over",
        product: "Samosa Stack",
        results: d.score,
        detail: [d.ending ? "ended: " + d.ending : "", d.caught != null ? "caught " + d.caught : "", d.isNew ? "new best" : ""].filter(Boolean).join(" · "),
      });
    } else if (d.action === "game_start") {
      send({ type: "game", action: "game_start", product: "Samosa Stack", detail: d.again ? "play again" : "first play" });
    }
  }

  // Game hooks without editing the game: watch its buttons and its game-over screen.
  function watchGame() {
    if (!isGame) return;
    var plays = 0;
    document.addEventListener("click", function (e) {
      var b = e.target && e.target.closest && e.target.closest("#play-btn, #again-btn");
      if (b) {
        plays += 1;
        window.dispatchEvent(new CustomEvent("ti:game", { detail: { action: "game_start", again: plays > 1 } }));
      }
    }, true);
    var veil = document.getElementById("over-veil");
    if (!veil || !window.MutationObserver) return;
    var wasHidden = veil.hidden;
    new MutationObserver(function () {
      if (wasHidden && !veil.hidden) {
        var score = parseInt(String(text(document.getElementById("over-score"))).replace(/\D/g, ""), 10);
        var title = text(document.getElementById("over-title")) || text(veil.querySelector("h2"));
        var detail = text(document.getElementById("over-detail"));
        var caught = (detail.match(/Caught\s+(\d+)/i) || [])[1];
        var flag = veil.querySelector("#over-flag");
        window.dispatchEvent(new CustomEvent("ti:game", {
          detail: {
            action: "game_over",
            score: isNaN(score) ? "" : score,
            ending: /tipped/i.test(title) ? "pile tipped" : /batch|done/i.test(title) ? "time up" : title,
            caught: caught,
            isNew: flag ? !flag.hidden : false,
          },
        }));
      }
      wasHidden = veil.hidden;
    }).observe(veil, { attributes: true, attributeFilter: ["hidden"] });
  }

  function loadPrivacyApi(cb) {
    try {
      if (window.Shopify && window.Shopify.customerPrivacy) return cb();
      if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
        window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () { cb(); });
        return;
      }
    } catch (e) {}
    cb();
  }

  window.TITrack = { send: send, source: source, device: device, allowed: allowed };

  source(); // capture the source on the first page of the visit
  document.addEventListener("click", onClick, true);
  document.addEventListener("change", onChange, true);
  document.addEventListener("submit", onSubmit, true);
  window.addEventListener("ti:game", onGame);

  function ready() {
    watchGame();
    loadPrivacyApi(trackViews);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
  else ready();
})();
